import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import DemandInfo from '../components/demand-info.vue';
import DeliverInfo from '../components/deliver-info.vue';
import PlDeliverInfo from '../components/pl-delivery-info.vue';
import ConfigureInfo from '../configuration-scheme/index.vue';
import ProductConfig from '../components/product-config.vue';
import ActionBar from './action-bar.vue';
import MetaInfo from '../components/meta-info';
import { curdDemandPageMixin } from '@/views/demand/mixin/demand';
import demandMixin from '../create/demand-mixin';

export default {
  components: {
    DemandInfo: DemandInfo,
    ActionBar: ActionBar,
    DeliverInfo: DeliverInfo,
    ConfigureInfo: ConfigureInfo,
    PlDeliverInfo: PlDeliverInfo,
    ProductConfig: ProductConfig,
    MetaInfo: MetaInfo
  },

  // data: demand/creationList/products; methods: getDemandDetail
  mixins: [curdDemandPageMixin, demandMixin],

  data: function data() {
    return {
      deliverGroupList: [],
      formConfig: {}
    };
  },


  computed: {
    isInteractiveMaterial: function isInteractiveMaterial() {
      return Number(this.demand.type) === 1;
    },
    demandId: function demandId() {
      return this.$route.params.id || '';
    },
    isShowPlDeliveryInfo: function isShowPlDeliveryInfo() {
      var showStatus = ['dev_ongoing', 'delivered'];
      return this.isInteractiveMaterial && showStatus.indexOf(this.demand.status) !== -1;
    },
    isShowDeliveryConfigure: function isShowDeliveryConfigure() {
      return this.isInteractiveMaterial && !_.isEmpty(this.configureData);
    }
  },

  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.demandId) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return _this.getDemandDetail(_this.demandId);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {}
};